"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = printLogger;

var _dsCore = require("@irim/ds-core");

// print logger middleware
// @author Pluto <huarse@gmail.com>
// @create 2020/01/05 18:10

/* eslint no-console: 0 */
async function printLogger(ctx) {
  const begin = performance.now();

  _dsCore.logger.debug(">>> ".concat(ctx.type || 'NET', " ").concat(ctx.method || 'GET', " ").concat(ctx.api || ctx.url), ctx.data);

  await ctx.next();
  const duration = performance.now() - begin;
  const logFn = ctx.response && ctx.response.success === false ? 'warn' : 'info';

  _dsCore.logger[logFn]("<<< ".concat(ctx.type || 'NET', " ").concat(ctx.method || 'GET', " ").concat(ctx.api || ctx.url, " ").concat(duration, "ms"), ctx.response);
}